<template>
    <veui-layout
        class="basic-container"
        :class="{
            'basic-container-no-bg': noBackground,
            'is-style-v2': isStyleV2,
            [`is-style-v2-${activeTheme}`]: true,
        }"
    >
        <template>
            <qingduo-header-v2/>
        </template>
        <veui-content>
            <router-view :key="$route.name"/>
        </veui-content>
        <veui-footer v-if="!hideFooter">
            <div class="copyright">{{ copyright }}</div>
        </veui-footer>
    </veui-layout>
</template>

<script>
/* globals ucCommonLogin */
import {Layout, Content, Footer} from 'veui';
import {ERROR_CODE_NOLOGIN} from '@/config/error';
import store from '@/store';
import {sendAlsLog} from '@/lib/als.js';
import QingduoHeaderV2 from './components/HeaderV2';

export default {
    name: 'basic-component',
    components: {
        'veui-layout': Layout,
        'veui-content': Content,
        'veui-footer': Footer,
        'qingduo-header-v2': QingduoHeaderV2
    },
    inject: ['$toast'],
    data() {
        return {
            copyright: '您所提交的内容应合法合规，且不得侵犯百度或第三人合法权益。您在本平台生成的内容仅限于百度推广平台内推广设置时使用。'
        };
    },
    computed: {
        noBackground() {
            // 帮助文档页面为白色背景
            return this.$route.name === 'helpDoc';
        },
        // 默认要显示页脚，如果不显示的，需要路由配置时指定
        hideFooter() {
            return this.$route.meta.hideFooter === true;
        },
        errInfo() {
            return store.state.app.errInfo;
        },
        isStyleV2() {
            return store.state.app.userInfo.isStyleV2;
        },
        activeTheme() {
            return this.$route.meta.theme || '';
        }
    },
    watch: {
        // 从数字人导航里的口播侧导跳到脚本文案页面，顶部应该切换active项
        $route(newVal, oldVal) {
            if (newVal.name !== oldVal.name) {
                this.alsLog({
                    f1: 'pageUv',
                    f2: 'show',
                    f5: newVal.name,
                    f11: oldVal.name
                });
            }
        },
        errInfo(to, from) {
            if (to.message === from.message) {
                return;
            }
            this.handleErrorTip(to);
        }
    },
    methods: {
        handleErrorTip(err = null) {
            if (err != null) {
                const {hairuoCode, message} = err;
                // -2未登录，-3无权限
                if (message
                    && (hairuoCode !== ERROR_CODE_NOLOGIN || !this.$route.meta.allowNotLogin)
                ) {
                    this.$toast.error(message);
                }
                console.log(err, message, hairuoCode, '本来应该toast');
            }
        },
        alsLog(data) {
            const userid = this.$store.state.app.hairuo?.userid;
            const optid = this.$store.state.app.hairuo?.optid;
            if (!userid) {
                return false;
            }
            // 如果没有f5，默认把页面路径带上
            if (data.f5 == null) {
                data.f5 = this.$route.name;
            }
            return sendAlsLog({
                ...data,
                f3: userid,
                f14: optid
            });
        }
    },
    mounted() {
        this.alsLog({
            f1: 'pageUv',
            f2: 'show',
            f11: `version_${this.isStyleV2 ? '2' : '1'}`
        });
        this.handleErrorTip(this.errInfo);

        window.sessionStorage.setItem('style_click_old', '0');
    }
};
</script>

<style lang="less" scoped>
@content-padding: 24px;
.basic-container {
    // background: url(https://qiaojiang.bj.bcebos.com/fe/qingduoBannerBg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-image: linear-gradient(-140.34deg, #C5D6FE 3.07%, #E6F2FF 45.99%, rgba(214, 221, 255, 0.6) 113.46%);
    width: 100%;
    height: 100vh;
    min-width: min(100%, fit-content);
    overflow: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    &.is-style-v2 {
        background-color: #ECF5FF;
        background-image: url(../assets/image/v2-content-bg.png);
        &-image {
            background-image: url(https://qiaojiang.bj.bcebos.com/fe/static/images/image_createbg.png);
        }
        &-text {
            background-image: url(https://qiaojiang.bj.bcebos.com/fe/static/images/text_createbg.png);
        }
        &-digitalhuman {
            background-image: url(https://qiaojiang.bj.bcebos.com/fe/static/images/digital_createbg.png);
        }
        &-video {
            background-image: url(https://qiaojiang.bj.bcebos.com/fe/static/images/video_createbg.png);
        }
        &-image-agent {
            background-image: url(https://now.bdstatic.com/stash/v1/9f89a08/aigc-fe/ee00117/bg1.png);
        }
    }

    // 帮助文档页，背景为白色
    &-no-bg {
        background-image: none !important;
        background-color: #FFF;
        .home-nav {
            background: #FFF;
            /* 阴影AI/S1 */
            box-shadow:
                0px 2px 8px 0px rgba(0, 71, 194, 0.01),
                0px 3px 9px 0px rgba(0, 71, 194, 0.02),
                0px 4px 10px 0px rgba(0, 71, 194, 0.03);
        }
        /deep/ .veui-layout-content{
            margin: @headerHeightNoBg 0 0 @content-padding !important;
            height: calc(100vh - @headerHeightNoBg - @footer-height);
            overflow: auto;
        }
        /deep/ .veui-layout-header {
            height: @headerHeightNoBg !important;
        }

    }
    /deep/ .veui-layout-header {
        box-shadow: none;
        background: transparent;
        height: @v2HeaderHeight;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
    }

    /deep/ .veui-layout-footer {
        padding: 12px 0;
        height: @footer-height;
        .copyright {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: #3A4978;
        }
    }

    // todo: content部分白底样式统一class类名，后续根据其他页面设计稿再优化结构
    /deep/ .veui-layout-content {
        margin: @v2HeaderHeight @content-padding 0 24px;
        height: calc(100vh - @v2HeaderHeight - @footer-height);
        z-index: 11;
    }
}

</style>
